import React from 'react';
import { Input, Section } from '../Shared';
import { CITING_SECTION_TITLE, PATENT_ASSIGNEE_INPUT_TEST_ID, PATENT_NUMBER_INPUT_TEST_ID, PATENT_CITING_SECTION_ID, PATENT_CITING_SECTION_TEST_ID, PATENT_TITLE_INPUT_TEST_ID, PATENT_TITLE, ASSIGNEE, PATENT_NUMBER } from './constants';
import { UNIQUE_KEY_DATE_FILED, LABEL_TEXT_DATE_FILED, PATENT_DATA_FILED_TEST_ID, UNIQUE_KEY_DATE_ISSUED, LABEL_TEXT_DATE_ISSUES, PATENT_DATA_ISSUED_TEST_ID } from '../../forms/patent/constants';
import { PubDate } from '../Shared/PubDate';
export var PatentCitingSection = function PatentCitingSection() {
  return /*#__PURE__*/React.createElement(Section, {
    sectionId: PATENT_CITING_SECTION_ID,
    title: CITING_SECTION_TITLE,
    ariaLabelledby: "".concat(PATENT_CITING_SECTION_ID, "-label"),
    dataTestId: PATENT_CITING_SECTION_TEST_ID
  }, /*#__PURE__*/React.createElement(Input, {
    name: "patent.title",
    labelText: PATENT_TITLE,
    "data-test": PATENT_TITLE_INPUT_TEST_ID,
    isRecommended: false
  }), /*#__PURE__*/React.createElement(Input, {
    name: "patent.assignee",
    labelText: ASSIGNEE,
    "data-test": PATENT_ASSIGNEE_INPUT_TEST_ID,
    isRecommended: false
  }), /*#__PURE__*/React.createElement(Input, {
    name: "patent.number",
    labelText: PATENT_NUMBER,
    "data-test": PATENT_NUMBER_INPUT_TEST_ID,
    isRecommended: false
  }), /*#__PURE__*/React.createElement(PubDate, {
    key: UNIQUE_KEY_DATE_FILED,
    labelText: LABEL_TEXT_DATE_FILED,
    "data-test": PATENT_DATA_FILED_TEST_ID,
    formikFieldNames: ['patent.dayfiled', 'patent.monthfiled', 'patent.yearfiled'],
    isRecommended: false
  }), /*#__PURE__*/React.createElement(PubDate, {
    key: UNIQUE_KEY_DATE_ISSUED,
    labelText: LABEL_TEXT_DATE_ISSUES,
    "data-test": PATENT_DATA_ISSUED_TEST_ID,
    formikFieldNames: ['patent.day', 'patent.month', 'patent.year'],
    isRecommended: false
  }));
};